import { lazy } from 'react';
import withLazyLoading from '../../hoc/withLazyLoading';
import { createCrumbHandle } from '../../utilities/auth';
import withPostHogTracker from '../../composeRouter';

const FormulaConfiguration = withLazyLoading(() => import('../../pages/FormulaConfiguration'));
const FormulaCreation = lazy(() =>
  import('../../pages/formulas').then(module => ({ default: module.FormulaCreation }))
);
const DynamicFormulaCreation = lazy(() =>
  import('../../pages/formulas').then(module => ({ default: module.DynamicFormulaCreation }))
);
const FormulaListing = lazy(() =>
  import('../../pages/formulas').then(module => ({ default: module.FormulaListing }))
);

const formulaRoutes = [
  {
    path: '/formulaConfiguration/:id',
    element: <FormulaConfiguration />,
    // authz-v2 TODO: Formula_Configuration_WE — gate server-side / useCan at component level
    handle: createCrumbHandle('Formula Configuration'),
  },
  {
    path: '/formula-list',
    handle: createCrumbHandle('Formulas'),
    children: [
      {
        index: true,
        element: withPostHogTracker(<FormulaListing />),
        // authz-v2 TODO: Formula_Configuration_WE — gate server-side / useCan at component level
      },
      {
        path: 'formula-creation/:formulaId?',
        element: withPostHogTracker(<FormulaCreation />),
        // authz-v2 TODO: Formula_Configuration_WE — gate server-side / useCan at component level
        handle: createCrumbHandle('Create Formula'),
      },
      {
        path: 'dynamic-formula-creation/:dynamicFormulaId?',
        element: <DynamicFormulaCreation />,
        // authz-v2 TODO: Formula_Configuration_WE — gate server-side / useCan at component level
        handle: createCrumbHandle('Create Dynamic Formula'),
      },
    ]
  },
];

export default formulaRoutes;
